export const APARTMENT_TYPES = [
  { key: 'studio', icon: 'apartment', label: 'Studios' },
  { key: 'loft', icon: 'weekend', label: 'Lofts' },
  { key: 'cobertura', icon: 'roofing', label: 'Coberturas' },
  { key: 'lote', icon: 'terrain', label: 'Lotes' },
] as const;

export function formatSquareMeters(value?: number | number[]) {
  const [min, max] = Array.isArray(value) ? value : [value];
  if (min === undefined || min === null) return '';
  if (max === undefined || max === null || max === min) return `${min}m²`;
  return `${min}m² a ${max}m²`;
}
